export const invalidMobile = "Please enter a valid mobile number."
export const invalidEmail = "Please enter a valid email address."
export const invalidKey = "Please enter a valid Unique Key to proceed."
export const invalidPassword = "You have entered an invalid password, please enter correct one."

export const emptyKey = "Please enter a valid Unique Key to proceed."
export const emptyMobile = "Please enter email or mobile number."
export const emptyPassword = "Please enter password."

//=======================Add Staff Errors=============================

export const NameRequired = 'Please enter full name of the user.'
export const EmailRequired = 'Please enter personal email of the user.'
export const MobileRequired = 'Please enter personal mobile number of the user.'
export const GenderRequired = 'Please select gender of the user.'
export const DobRequired = 'Please metion date of birth of the user.'
export const IdentityTypeRequired = 'Please select type of identity proof of the user.'
export const IdentityNumberRequired = 'Please enter document number of identity proof of the user.'
export const IdentityProofRequired = 'Please upload document for identity proof of the user.'
export const AddressTypeRequired = 'Please select type of address proof of the user.'
export const AddressNumberRequired = 'Please enter document number of address proof of the user.'
export const AddressProofRequired = 'Please upload document for address proof of the user.'
export const EmployeeIdRequired = 'Please enter employee id of the user.'
export const DesignationRequired = 'Please enter designation of the user.'
export const DepartmentRequired = 'Please enter department of the user.'
export const OfficeEmailRequired = 'Please enter official email of the user.'
export const OfficeMobileRequired = 'Please enter official mobile of the user.'
export const DojRequired = 'Please select date of joining of the user.'
export const PermanentAddressRequired = 'Please enter permanent address of the user.'
export const PermanentCountryRequired = 'Please select permanent country of the user.'
export const PermanentStateRequired = 'Please select permanent state of the user.'
export const PermanentCityRequired = 'Please select permanent city of the user.'
export const PermanentPincodeRequired = 'Please select permanent pincode of the user.'
export const PresentAddressRequired = 'Please enter present address of the user.'
export const PresentCountryRequired = 'Please select present country of the user.'
export const PresentStateRequired = 'Please select present state of the user.'
export const PresentCityRequired = 'Please select present city of the user.'
export const PresentPincodeRequired = 'Please select present pincode of the user.'
export const ActiveUptoRequired = 'Please select active date of the user.'
export const StatusRequired = 'Please select status of the user.'

export const ValidEmailError = 'Please enter valid email address of the user.'
export const ValidMobileError = 'Please enter valid mobile number of the user.'
export const ValidDobError = 'Date of birth should be less then date of joining & active date.'
export const ValidDojError = 'Date of joining should be less then active date & should be greater than date of birth.'
export const ValidActiveUptoError = 'Active Date should be less then should be greater than date of joining.'

export const SomethingWrong = 'Something went wrong, try again later.'

export const MobileAlreadyRegistered = 'Personal mobile number already registered.'
export const EmployeeIdAlreadyRegistered = 'Employee id already registered.'
export const NotAuthorised = 'You are not authorised to proceed.'
export const NotApproved = 'Please approve in order to continue.'


//=======================Add Client Errors=============================


export const ContactNameRequired = 'Please enter full name of contact person.'
export const ContactEmailRequired = 'Please enter email address of contact person.'
export const ContactMobileRequired = 'Please enter mobile number of contact person.'
export const ContactDesignationRequired = 'Please enter designation of contact person.'
export const ContactMobileInvalid = 'Please enter a valid mobile number of contact person.'
export const ContactEmailInvalid = 'Please enter a valid email address of contact person.'
export const ContactAlreadyRegistered = 'Contact person already registered.'

export const BillingAddressRequired = 'Please enter billing address.'
export const BillingCountryRequired = 'Please select billing country.'
export const BillingStateRequired = 'Please select billing state.'
export const BillingCityRequired = 'Please select billing city.'
export const BillingPincodeRequired = 'Please enter billing pincode.'
export const BillingGstNumberRequired = 'Please enter billing gst number.'
export const BillingGstCertificateRequired = 'Please upload billing gst certificate.'
export const AddressAlreadyPresent = 'Billing Address already present.'


export const ClientNameRequired = 'Please enter client'+"'"+'s name.'
export const ClientEmailRequired = 'Please enter client'+"'"+'s email.'
export const ClientPhoneRequired = 'Please enter client'+"'"+'s phone number.'
export const ClientPartnerRequired = 'Please enter client'+"'"+'s partner name.'
export const ClientIndustryRequired = 'Please specify client'+"'"+'s industries.'
export const ClientLegalNumberRequired = 'Please enter client'+"'"+'s legal registration number.'
export const ClientLegalCertificateRequired = 'Please upload client'+"'"+'s legal registraion certificate.'
export const ClientPanNumberRequired = 'Please enter client'+"'"+'s PAN number.'
export const ClientPanCertificateRequired = 'Please upload client'+"'"+'s PAN certificate.'
export const ClientCreditLimitRequired = 'Please enter client'+"'"+'s credit limit.'
export const ClientCreditPeriodRequired = 'Please enter client'+"'"+'s credit period.'
export const ClientTurnoverRequired = 'Please enter client'+"'"+'s previous year annual turnover.'


export const RegAddressRequired = 'Please enter client'+"'"+'s registered office address.'
export const RegCountryRequired = 'Please enter client'+"'"+'s registered office country.'
export const RegStateRequired = 'Please enter client'+"'"+'s registered office state.'
export const RegCityRequired = 'Please enter client'+"'"+'s registered office city.'
export const RegPincodeRequired = 'Please enter client'+"'"+'s registered office pincode.'
export const RegGstNumberRequired = 'Please enter client'+"'"+'s registered office GST number.'
export const RegGstCertificateRequired = 'Please enter client'+"'"+'s registered office GST certificate.'
export const CorporateAddressRequired = 'Please enter client'+"'"+'s corporate office address.'
export const CorporateCountryRequired = 'Please enter client'+"'"+'s corporate office country.'
export const CorporateStateRequired = 'Please enter client'+"'"+'s corporate office state.'
export const CorporateCityRequired = 'Please enter client'+"'"+'s corporate office city.'
export const CorporatePincodeRequired = 'Please enter client'+"'"+'s corporate office pincode.'
export const CorporateGstNumberRequired = 'Please enter client'+"'"+'s corporate office GST number.'
export const CorporateGstCertificateRequired = 'Please enter client'+"'"+'s corporate office GST certificate.'

export const BillingDataRequired = 'Please add atleast 1 client'+"'"+'s billing address.'
export const ContactPersonRequired = 'Please add atleast 1 contact person.'
export const ClientAlreadyPresent = 'Client name or legal number already present.'
export const ClientAdded = 'Client information has been successfully added.'



//=======================Client List Errors=============================


export const ClientListStaffRequired = 'Please select staff.'
export const ClientListContactRequired = 'Please select contact person.'
export const ClientActivated = 'Crendentials has been successfully sent to client.'



//=======================Reset Password Errors=============================

export const OldPasswordRequired = 'Please enter last remembered password.'
export const OldPasswordInvalid = 'Invalid old password.'
export const NewPasswordRequired = 'Please enter new password.'
export const ConfirmPasswordRequired = 'Please re-type new password.'
export const NoPasswordMatch = 'Password donot match.'
export const NewPasswordSame = 'New password cannot be same as old password.'


//=======================Job Post Errors=============================


export const TitleRequired = 'Please enter the title for the job.'
export const TypeRequired =  'Please select the type of the job.'
export const CategoryRequired = 'Please select the category of the job.' 
export const AreaRequired = 'Please select the functional area of the job.'
export const CompanyRequired = 'Please enter the company name for which you are hiring.'
export const ClosingDateRequired = 'Please select the closing date of the job opening.' 
export const OpeningDateRequired =  'Please select the opening date of the job opening.'
export const OpeningDateError = 'Opening date is invalid, must be less than closing date.'
export const JobsStatusRequired = 'Please select the status of the job opening.'
export const PostionsRequired = 'Please select the no. of positions opened for the job.' 
export const RemoteWorkRequired = 'Please select if the job can pe performed remotely.' 
export const JobDescriptionRequired = 'Please define the job description.' 
export const SkillSetRequired = 'Please define the skills required for the job.'
export const DutiesRequired = 'Please define the duties involved in the job.'
export const ExperienceRequired = 'Please define the experience requirements for the job.' 
export const MinSalaryRequired = 'Please enter the minimum salary package.'
export const MaxSalaryRequired = 'Please enter the manimum salary package.'
export const SalaryTypeRequired = 'Please enter the salary type.'
export const MinExperienceRequired = 'Please enter the minimum experience required for the job.' 
export const MaxExperienceRequired = 'Please enter the maximum experience required for the job.'
export const ExperienceTypeRequired = 'Please select the experience type.'
export const CountryRequired = 'Please select country for the opening.'
export const StateRequired = 'Please select state for the opening.'
export const PincodeRequired = 'Please enter pincode for the opening.'
export const CityRequired = 'Please select city for the opening.'


export const InvalidOtp = 'You have entered an invalid OTP.'
export const CandidateAlreadyRegitered = 'Email already registered.'
export const CandidateEmailNotVerified = 'Email not verified, kindly verify your email to login.'
export const CandidateNotRegitered = 'Email/Mobile not registered, kindly signup.'
export const ResumeRequired = 'Kindly select resume to upload.'


export const InterviewerEmailRequired = 'Please enter interviewer email address.'
export const InterviewerEmailInvalid = 'Please enter valid email address.'
export const CanditdateEmailRequired = 'Please enter candidate email address.'
export const InterviewDateTimeRequired = 'Please enter date & time of interview.'